import { BellOutlined } from "@ant-design/icons";
import { Badge, Dropdown } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AdminNotification, NotificationService } from "../../api/notificationService";

const POLL_INTERVAL_MS = 30000;
const PREVIEW_SIZE = 5;

const NotificationBell = () => {
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const [items, setItems] = useState<AdminNotification[]>([]);

  const refreshCount = useCallback(async () => {
    try {
      setUnreadCount(await NotificationService.unreadCount());
    } catch {
      // keep the previous count; the next poll retries
    }
  }, []);

  const refreshPreview = useCallback(async () => {
    try {
      const result = await NotificationService.list(0, PREVIEW_SIZE);
      setItems(result.items);
    } catch {
      setItems([]);
    }
  }, []);

  useEffect(() => {
    refreshCount();
    const timer = setInterval(refreshCount, POLL_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [refreshCount]);

  const openNotification = async (item: AdminNotification) => {
    if (!item.read) {
      await NotificationService.markRead(item.id).catch(() => undefined);
      refreshCount();
    }
    navigate("/notifications");
  };

  const overlay = (
    <div
      style={{
        width: 320,
        background: "#fff",
        color: "#000",
        borderRadius: 8,
        boxShadow: "0 4px 16px rgba(0,0,0,.2)",
      }}
    >
      <div style={{ padding: "8px 12px", fontWeight: 600, borderBottom: "1px solid #eee" }}>
        Notifications
      </div>
      {items.length === 0 && <div style={{ padding: 12 }}>No notifications</div>}
      {items.map((item) => (
        <div
          key={item.id}
          onClick={() => openNotification(item)}
          style={{
            padding: "8px 12px",
            cursor: "pointer",
            background: item.read ? "#fff" : "#fff7e6",
            borderBottom: "1px solid #f3f3f3",
          }}
        >
          <div style={{ fontWeight: 600 }}>{item.title}</div>
          <div style={{ fontSize: 12 }}>{item.body}</div>
        </div>
      ))}
      <div
        onClick={() => navigate("/notifications")}
        style={{ padding: 8, textAlign: "center", cursor: "pointer", color: "#1677ff" }}
      >
        View all
      </div>
    </div>
  );

  return (
    <Dropdown
      dropdownRender={() => overlay}
      trigger={["click"]}
      placement="top"
      onOpenChange={(open) => open && refreshPreview()}
    >
      <div
        style={{
          width: 36,
          height: 36,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
      >
        <Badge count={unreadCount} size="small">
          <BellOutlined style={{ fontSize: 18, color: "#fff" }} />
        </Badge>
      </div>
    </Dropdown>
  );
};

export default NotificationBell;
